import { ActionsCenter } from './ActionsCenter';
import { AdDescription } from './AdDescription';
import { Header } from './Header';
import { PhoneScamNotify } from '../../../components/PhoneScamNotify';
import { Photos } from './Photos';
import { PlanDetails } from './PlanDetails';
import React from 'react';
import { ResumeWrapper } from './style';
import { VehicleChassis } from './VehicleChassis';
import { VehicleData } from './VehicleData';
import { VehicleDifferentials } from './VehicleDifferentials';
import { VehicleOptionals } from './VehicleOptionals';
import { VehiclePlate } from './VehiclePlate';
import { VehicleTitle } from './VehicleTitle';
import { pushSellerPFDashboardEvent } from '../../../../utils/pushToDataLayer';
import { useAdContext } from '../../../store/contexts/ad';
import { useWebappFlags } from '../../../hooks/useWebAppFlags';

export function Resume(): JSX.Element {
  const { openEditView, transition } = useAdContext();
  const { getFlagOnSession } = useWebappFlags();

  return (
    <ResumeWrapper isEditOpen={!!openEditView} isTransition={transition}>
      <Header />
      <VehicleTitle />
      <PhoneScamNotify
        handleCardClick={() =>
          pushSellerPFDashboardEvent('confira mais dicas', 'seguranca', {
            location: 'detalhes do anúncio'
          })
        }
        handleMainButtonModalClick={() =>
          pushSellerPFDashboardEvent('entendi', 'modal seguranca', {
            location: 'detalhes do anúncio'
          })
        }
        handleCloseModalClick={() =>
          pushSellerPFDashboardEvent('fechar', 'modal seguranca', {
            location: 'detalhes do anúncio'
          })
        }
      />
      <VehiclePlate />
      {getFlagOnSession('validacaoChassi') && <VehicleChassis />}
      <VehicleData />
      <VehicleOptionals />
      <VehicleDifferentials />
      <AdDescription />
      <Photos />
      <PlanDetails />
      <ActionsCenter />
    </ResumeWrapper>
  );
}
